import React from "react";
import { useProfileContext } from "@/contexts/ProfileContext";
import { useAuth } from "@/hooks/domains/auth/useAuth";
import ProfileSectionHandler from "@/components/dashboard/content/ProfileSectionHandler";
import ServicesSection from "@/components/dashboard/content/ServicesSection";

export default function PortfolioPage() {
  const { user } = useAuth();
  const { profile, isLoading } = useProfileContext();


  // Don't show loading screen if we're just refetching - let PortfolioSection handle it
  // Only show this loading screen on initial mount with no profile data
  if (!profile) {
    return (
      <div className="relative z-10 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
        <div className="animate-pulse space-y-6">
          <div className="h-8 bg-gray-200 rounded w-1/4"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(6)].map((_, i) => (
              <div
                key={i}
                className="aspect-square bg-gray-200 rounded-lg"
              ></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // If we have a profile, render immediately even if still loading
  if (profile) {
    return (
      <div className="relative z-10 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
        <ServicesSection />
        <ProfileSectionHandler type="portfolio" user={user} profile={profile} isLoading={isLoading} />
      </div>
    );
  }

  // Fallback for when we have no profile and not loading
  return (
    <div className="relative z-10 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
      <ServicesSection />
      <ProfileSectionHandler type="portfolio" user={user} profile={profile} isLoading={isLoading} />
    </div>
  );
}
